/**
 * 脸部验证 api
 */
import * as API from '../'
import $const from '../../common/constant'


export default {
  /**
   * 生成验证id
   * @param params
   * @returns {Promise<*>}
   */
  vid: (params)=> {
    return API.POST($const.apiServer.Tranning + '/v-face-image/vid', params);
  },
  /**
   * 获取验证状态
   * @param params
   * @returns {Promise<*>}
   */
  vidStatus: (params)=> {
    return API.POST($const.apiServer.Tranning + '/v-face-image/vid-status', params);
  },
  // 验证是否登录？？？
  vFaceAuth: (params)=> {
    return API.POST($const.apiServer.Tranning + '/v-face-image/v-face-auth', params);
  },
  faceAuthStatus: (params)=> {
    return API.GET($const.apiServer.Tranning + '/v-face-image/v-face-auth-status', params);
  },



  /**
   * 认证详情分页查询
   * @param params
   * @returns {Promise<*>}
   */
  detailPage: (params)=> {
    return API.GET($const.apiServer.Tranning + '/v-face-image/detail-page', params);
  }
}



// WEBPACK FOOTER //
// ./src/api/training/api_vface.js